// extracted by mini-css-extract-plugin
module.exports = {"hide-cursor":"DemoPack_hide-cursor__CVpKL","styles_type__2Teeh":"DemoPack_styles_type__2Teeh__ciNzq","DemoPack":"DemoPack_DemoPack__sg59x"};